
export default {
    props: [
        'value',
        'genres',
    ],

    computed: {
        genre_input_id: {
            get: function () {
                return this.value
            },
            set: function (value) {
                this.$emit('input', value)
            }
        },
    },

}
